import { ServerOptions } from '@commercetools/frontend-sdk';
import { ComposableCommerceEventsB2B } from '../../types/events/ComposableCommerceEventsB2B';
import { ProductPaginatedResult } from '@shared/types/result';
import { CommercetoolsSdk } from '../Integration';

export type CustomActions = {
  productInventory: any;
  deliveryEstimateData: any;
  orderTrack: any;
  orderHistory: any;
  activeOrders: any
  submitContactUs: any;
  videoList: any;
  addProductToWishlist: any;
  getCustomerWishlist: any;
  removeProductFromWishlist: any;
};

export const getCustomActions = (sdk: CommercetoolsSdk<ComposableCommerceEventsB2B>): CustomActions => {
  return {
    productInventory: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.call<ProductPaginatedResult>({
        actionName: 'custom/productInventory',
        payload: payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    deliveryEstimateData: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.call<ProductPaginatedResult>({
        actionName: 'custom/deliveryEstimateData',
        payload: payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },

    orderTrack: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.call<ProductPaginatedResult>({
        actionName: 'custom/orderTrack',
        payload: payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    orderHistory: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.call<ProductPaginatedResult>({
        actionName: 'custom/orderHistory',
        payload: payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    activeOrders: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.call<ProductPaginatedResult>({
        actionName: 'custom/activeOrders',
        payload: payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    submitContactUs: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.call<ProductPaginatedResult>({
        actionName: 'custom/submitContactUs',
        payload: payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },

    videoList: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.call<ProductPaginatedResult>({
        actionName: 'custom/videoList',
        payload: payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    addProductToWishlist: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.call<ProductPaginatedResult>({
        actionName: 'shoppinglist/add-product-to-wishlist',
        payload: payload,
        serverOptions: options.serverOptions,
      });
      if (!response.isError && typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('wishlist-updated'));
      }
      return response;
    },
    getCustomerWishlist: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.call<ProductPaginatedResult>({
        actionName: 'shoppinglist/get-customer-wishlist',
        payload: payload,
        serverOptions: options.serverOptions,
      });
      return response;
    },
    removeProductFromWishlist: async (payload: any, options: { serverOptions?: ServerOptions } = {}) => {
      const response = await sdk.call<ProductPaginatedResult>({
        actionName: 'shoppinglist/remove-product-from-wishlist',
        payload: payload,
        serverOptions: options.serverOptions,
      });
      if (!response.isError && typeof window !== 'undefined') {
        window.dispatchEvent(new CustomEvent('wishlist-updated'));
      }
      return response;
    },
  };
};
